import React from "react";
import { X } from "react-feather";
import { Button, Modal, Spinner } from "reactstrap";
import { updatedCampaignIcon } from "../../../Shared/SVGs/Shared";

const Step4InfoModal = ({ open, toggle, handleSubmit, loading }) => {
  return (
    <Modal
      backdropClassName="back-drop"
      isOpen={open}
      toggle={toggle}
      contentClassName="custom-modals-info"
    >
      <div className="cross">
        <div onClick={toggle}>
          <X size={30} color="black" strokeWidth="2px" />
        </div>
      </div>
      <div className="d-flex justify-content-center mb-1">
        {updatedCampaignIcon}
      </div>
      <p className="step-text">Your campaign is ready to go live!</p>
      <div className="d-flex justify-content-center">
        <div className="modal-text">
          Click 'Activate' to launch your campaign. Once live, you can share it
          with your customers by generating a <b>QR code</b> or using the{" "}
          <b>provided link</b>. Vyrill will then save you design time by
          creating the campaign banner for you.
        </div>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <Button
          style={{
            width: "150px",
            height: "50px",
          }}
          size="lg"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          Activate {loading && <Spinner size="sm" />}
        </Button>
      </div>
    </Modal>
  );
};

export default Step4InfoModal;
